import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
const store ={
  state:{ //状态对象：共享值的集合
    
  },
  mutations:{  //同步修改
    set(state, obj){//初始化
      for(let name in obj){
        state[name] = obj[name];
      }
    },
  },
  getters:{//监测状态
    userInfo:(state)=>{
      return state
    },
  },
  actions:{//异步修改
    addActions(context,obj){ //context 上下文对象，同管全局
      context.commit('init',obj); //上下文对象调用commit执行add方法
    },
    updateUser(context,obj){ //context 上下文对象，同管全局
      return new Promise((resolve, reject)=>{
        
      })
    },
  }
}

export default store

